import { maxSizeMobile } from '@/theme';
import styled from '@emotion/styled';

export const Root = styled.div`
    @media (max-width: ${maxSizeMobile}) {
        margin-top: 30px;
        margin-bottom: 30px;
    }
`